import React, { useEffect } from "react";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Protected from "./protected";
import { useSelector, useDispatch } from "react-redux";
// import { getUserProfile } from "../features/user/userSlice";
import LandingPage from "../Components/LandingPage";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import Dashboard from "../pages/Dashboard";
import MyProfileForm from "../pages/MyProfileForm";
import OrdersTable from "../pages/orders/OrdersTable";
import ProductsList from "../pages/products/ProductsList";
import UsersList from "../pages/users/UsersList";
import AddUser from "../pages/users/AddUser";
import AddProduct from "../pages/products/AddProduct";
import CategoriesList from "../pages/categories/CategoriesList";
import AddCategory from "../pages/categories/AddCategory";
import BrandsList from "../pages/brands/BrandsList";
import AddBrand from "../pages/brands/AddBrand";
import CouponsList from "../pages/coupons/CouponsList";
import AddCoupon from "../pages/coupons/AddCoupon";
import Review from "../pages/reviews/ReviewsLists";
import AddReview from "../pages/reviews/AddReview";
import SettingsList from "../pages/settings/SettingsList";
import PaymentsList from "../pages/payments/PaymentsList";
import ProductUserLists from "../pages/userpages/products/ProductUserLists";
import WishList from "../pages/userpages/wishlist/Wishlist";
import CouponUserList from "../pages/userpages/coupons/CouponUserLists";
import CartUserList from "../pages/userpages/carts/CartUserLists";
import OrderUserList from "../pages/userpages/orders/OrderUserLists";
import ResetPassword from "../pages/resetpassword/ResetPassword";
import NewPassword from "../pages/resetpassword/NewPassword";
import CartComponent from "../Components/cart/CartComponent";
import WishlistComponent from "../Components/wishlist/WishlistComponent";
import CategoriesPage from "../Components/CategoryPage";
import ProductDetail from "../Components/ProductDetails";
import AboutUs from "../Components/aboutUs/AboutUs";
import ContactUs from "../Components/contactUs/ContactUs";
import GeneralInqury from "../Components/Inquiries/generalInqury/GeneralInqury"
import BulkInqury from "../Components/Inquiries/bulkInqury/BulkInqury";
import CorporateInqury from "../Components/Inquiries/corporateInqury/CorporateInqury";

const RoutesWithLogging = () => {
  const dispatch = useDispatch();
  // const { profile } = useSelector((state) => state.user);
  const userRole = localStorage.getItem("role");
  const userToken = localStorage.getItem("token");
  const isAdmin = userRole === "admin";
  const isAuthenticated = !!userToken;

  // Fetch user profile to set role
  // useEffect(() => {
  //   if (isAuthenticated) dispatch(getUserProfile());
  // }, [dispatch, isAuthenticated]);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/">
        {/* Public Routes */}
        <Route index element={<LandingPage />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="resetpassword" element={<ResetPassword />} />
        <Route path="/reset/:token" element={<NewPassword />} />
        <Route path="productdetail/:id" element={<ProductDetail />} />
        <Route path="about" element={<AboutUs />} />
        <Route path="contact" element={<ContactUs />} />

        <Route path="general-inquiry" element={<GeneralInqury />} />
        <Route path="bulk-inquiry" element={<BulkInqury />} />
        <Route path="corporate-inquiry" element={<CorporateInqury />} />
        
        {/* Protected Routes */}
        {isAuthenticated && (
          <Route element={<Protected />}>
            {/* Role-based Redirection */}
            {isAdmin ? (
              // If Admin, go to the Dashboard
              <Route path="/" element={<Navigate to="/dashboard" />} />
            ) : (
              // If User or Undefined role, go to the Landing Page
              <Route path="/" element={<Navigate to="/" />} />
            )}

            {/* Admin Routes */}
            {isAdmin ? (
              <>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="orderstable" element={<OrdersTable />} />
                <Route path="productlist" element={<ProductsList />} />
                <Route path="userslist" element={<UsersList />} />
                <Route path="adduser" element={<AddUser />} />
                <Route path="addproduct" element={<AddProduct />} />
                <Route path="categorieslist" element={<CategoriesList />} />
                <Route path="addcategory" element={<AddCategory />} />
                <Route path="brandslist" element={<BrandsList />} />
                <Route path="addbrand" element={<AddBrand />} />
                <Route path="couponslist" element={<CouponsList />} />
                <Route path="addcoupon" element={<AddCoupon />} />
                <Route path="review" element={<Review />} />
                <Route path="addreview" element={<AddReview />} />
                <Route path="settinglist" element={<SettingsList />} />
                <Route path="paymentlist" element={<PaymentsList />} />
              </>
            ) : (
              <>
                {/* User Routes */}
                <Route
                  path="dashboard"
                  element={<Navigate to="/productuserlist" />}
                />
                <Route path="productuserlist" element={<ProductUserLists />} />
                <Route path="wishlist" element={<WishList />} />
                <Route path="cart" element={<CartComponent />} />
                <Route
                  path="wishlistcomponent"
                  element={<WishlistComponent />}
                />
                <Route path="couponuserlist" element={<CouponUserList />} />
                <Route path="cartuserlist" element={<CartUserList />} />
                <Route path="orderuserlist" element={<OrderUserList />} />
                <Route path="categorypage" element={<CategoriesPage />} />
              </>
            )}
            {/* Common Routes */}
            <Route path="myProfileForm" element={<MyProfileForm />} />
          </Route>
        )}

        {/* 404 Page */}
        <Route
          path="*"
          element={<h1>404 - Page Not Found (No Token Found, Please Login)</h1>}
        />
      </Route>
    )
  );

  return <RouterProvider router={router} />;
};

const Index = () => {
  return <RoutesWithLogging />;
};

export default Index;
